import { css } from 'styled-components';
import { applyTypography, TYPOGRAPHY_VARIANTS } from '../../styled/theme/typography-utils';

/**
 * Base button styles for all LytButton variants
 * 
 * Props:
 * - isIconOnly: boolean - true when button contains only an icon (no text)
 * - isCompact: boolean - true for compact padding variant
 */
export const baseButtonStyles = css`
    /* Apply typography - 14px medium weight for button labels */
    ${applyTypography(TYPOGRAPHY_VARIANTS.SIZE_1_MEDIUM)}

  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: ${(props) => {
    if (props.isIconOnly) {
      return '4px';
    }
    return '8px';
  }};
  height: ${(props) => props.isCompact ? '24px' : '32px'};
  box-sizing: border-box;
  gap: 4px;
  line-height: normal;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s, outline 0.2s;
  min-width: 0;

  /* Icons should never shrink */
  & > svg,
  & > span:has(svg) {
    flex-shrink: 0;
  }
  
  &.lyt-button-large {
    padding: ${(props) => {
      if (props.isIconOnly) {
        return props.isCompact ? '12px' : '16px';
      }
      return props.isCompact ? '8px 16px' : '12px 16px';
    }};
  }
  
  &:disabled {
    cursor: not-allowed;
  }
`; 